import chartClasses from "@shared/charts/chart.module.css";
import formatDateWithTime from "@shared/charts/formatDateWithTime";
import formatNumber from "@shared/charts/formatNumber";
import { SherlockChangeDetails, SherlockMetricType } from "@shared/http/apiTypes/sherlockApiTypes";
import { SHERLOCK_ACTUAL_DATA_LABEL, SHERLOCK_PREDICTED_DATA_LABEL } from "../InvestigationResult";
import formatChangeTooltipContent from "./formatChangeTooltipContent";

const formatValueByMetric = (
  value: number,
  metricType: string,
  currencySymbol?: string,
  predicted?: boolean,
): string => {
  switch (metricType) {
    case "ap_conversions":
      return predicted ? value.toFixed(2) : Math.round(value).toString();
    case "spend":
      return `${currencySymbol} ${formatNumber(value)}`;
    case "XPC":
      return value.toFixed(2);
    default:
      return value.toString();
  }
};

export const sherlockChartTooltipRenderer = (
  time: Date,
  values: { label: string; value: number | undefined }[],
  selectedMetric: SherlockMetricType,
  changeDetails?: SherlockChangeDetails[],
  currencySymbol?: string,
) => {
  const formattedTooltipContent = changeDetails
    ? changeDetails.map(change => {
        const { changed_attribute, date, prev_value, new_value } = change;

        const content = formatChangeTooltipContent(changed_attribute, prev_value, new_value);
        return { content, date };
      })
    : undefined;

  const changeTime = changeDetails && changeDetails.length > 0 ? new Date(changeDetails[0].date) : time;

  const actualData = values.find(v => v.label === SHERLOCK_ACTUAL_DATA_LABEL);
  const predictedData = values.find(v => v.label === SHERLOCK_PREDICTED_DATA_LABEL);

  return (
    <>
      <div className={chartClasses.sherlockChangeTooltipHeader}>{formatDateWithTime(new Date(changeTime))}</div>

      <div key={actualData?.label} className={chartClasses.sherlockSeriesValue}>
        Actual: {formatValueByMetric(actualData?.value || 0, selectedMetric, currencySymbol)}
      </div>

      {predictedData && (
        <div key={predictedData?.label} className={chartClasses.sherlockSeriesValue}>
          <div key={predictedData?.label} className={chartClasses.sherlockSeriesValue}>
            Predicted: {formatValueByMetric(predictedData?.value || 0, selectedMetric, currencySymbol, true)}
          </div>
        </div>
      )}

      {formattedTooltipContent &&
        formattedTooltipContent.length > 0 &&
        formattedTooltipContent.map((change, index) => (
          <div key={index} className={chartClasses.sherlockChangeTooltipContent}>
            {change.content}
          </div>
        ))}
    </>
  );
};
